import React from 'react';
import classnames from 'classnames';

import styles from './LoaderColumn.module.scss';

interface LoaderColumnProps {
  className?: string;
  type?: string;
}

export const LoaderColumn: React.FC<LoaderColumnProps> = ({ className, type = 'Column' }) => {
  return (
    <div
      className={classnames(className, styles.container, {
        [styles[`type-${type}`]]: type,
      })}
    />
  );
};
